import { render, staticRenderFns } from "./otcOrder.vue?vue&type=template&id=35287c82&scoped=true&"
import script from "./otcOrder.vue?vue&type=script&lang=js&"
export * from "./otcOrder.vue?vue&type=script&lang=js&"
import style0 from "./otcOrder.vue?vue&type=style&index=0&id=35287c82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35287c82",
  null
  
)

export default component.exports